module.exports = __webpack_public_path__ + "img/020.10050c0f.jpg";